<template>
  <div class="notice-container">
    <el-dropdown trigger="click">
      <el-badge :value="value" :hidden="canShow()" class="item" @click.native="value === 0 ? showNoticeList(): ''">
        <div :class="value > 0 ? 'notice-icon-box-animation notice-icon-box' : 'notice-icon-box'">
          <el-button type="text" icon="el-icon-bell" size="medium" style="color: rgb(96, 98, 102);margin-top:1px" />
        </div>
      </el-badge>
      <el-dropdown-menu slot="dropdown" :class="value > 0?'dropdown-message':'dropdown-message dropdown-message-hidden'">
        <div class="dropdown-message-context">

          <el-dropdown-item v-for="item in noticeMsg" :key="item.id" class="notice-content-group" @click.native="showNoticeListOnly(item.id)">
            <span class="notice-content-icon">
              <i :class="item.level===0?'el-icon-info':item.level===1?'el-icon-warning':'el-icon-error'" :style="item.level===0?'color: #67c23a;':item.level===1?'color: #e6a23c;':'color: #f56c6c;'" />
            </span>
            <span class="notice-content">
              <span class="notice-title">
                <span class="notice-title-context">{{ item.title }}</span>
                <span class="notice-time">{{ formatTime(item.create_time) }}</span>
              </span>
              <el-tooltip :content="item.message" placement="right" effect="light" popper-class="popper-message">
                <span class="notice-message">{{ item.message }}</span>
              </el-tooltip>
            </span>
          </el-dropdown-item>
          <el-dropdown-item v-if="noticeMsg.length>0" class="notice-content-group" style="border:0" @click.native="showNoticeList">
            <span class="notice-content-title">查看全部{{ value }}条未读信息</span>
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { getUnReadList, getInfo } from '@/api/notice'
import { formatTime } from '@/utils'

export default {
  name: 'Notice',
  data() {
    return {
      value: 0,
      noticeMsg: []
    }
  },
  computed: {
    logged: function() {
      return this.$store.getters.uid !== 0
    }
  },
  watch: {
    '$store.getters.ws_message': function(response) {
      const data = response.data
      if (data.notice_type !== 1) {
        return
      }
      this.value++
      this.noticeMsg.unshift({ id: data.id, title: data.title, message: data.message, level: data.level, create_time: data.create_time })
      // default 和 denied 效果一样，表示用户不允许该网站显示通知，granted表示用户允许该网站显示通知
      if (!('Notification' in window)) {
        if (Notification.permission === 'granted') {
          const notification = new Notification(data.title, { body: data.message })
          notification.onclick = (event) => {
            this.showNoticeListOnly(data.id)
            notification.close()
          }
        }
        this.noticeMsg.splice(6)
      }
    }
  },
  created() {
    this.notificationRequest() // 用户浏览器推送
    this.getUnReadList()
    this.initTimer()
  },
  methods: {
    formatTime,
    notificationRequest() {
      // 用户浏览器推送
      // 询问用户是否同意推送
      if ('Notification' in window) {
        Notification.requestPermission(res => {}) // res 与 Notification.permission皆可判断用户状态
      }
    },
    showNoticeListOnly(id) {
      // 查看单条
      getInfo({ id: id }).then(res => {
        this.showDetail(res.data.url, res.data.param)
        this.getUnReadList()
      })
    },
    showDetail(url, param) {
      if (url === '') {
        return
      }
      const argv = {
        path: url,
        query: JSON.parse(param)
      }
      this.$router.push(argv)
    },
    canShow() {
      return this.value === 0
    },
    showNoticeList() {
      this.value = 0
      this.noticeMsg = []
      this.$router.push({
        path: '/user/info',
        query: {
          type: 'notice'
        }
      })
    },
    getUnReadList() {
      if (!this.logged) {
        return
      }
      getUnReadList().then((response) => {
        this.value = response.data.total
        this.noticeMsg = response.data.list
        const version = response.data.version
        if (!version) {
          return false
        }
        if (localStorage.getItem('version_data')) {
          const oldVersion = localStorage.getItem('version_data')
          if (oldVersion !== version) {
            // 两次版本不一致
            const oldVersionList = oldVersion.replace('v', '').split('.')
            const newVersionList = version.replace('v', '').split('.')
            if (oldVersionList[0] !== newVersionList[0] || newVersionList[1] % 2 === 0) {
              // 强刷 大版本不同，小版本为偶数
              location.reload(true)
            } else {
              this.$confirm(
                '当前有版本更新，是确定是否刷新页面',
                '版本更新',
                {
                  confirmButtonText: '刷新',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
              ).then(() => {
                location.reload(true)
              })
            }
          }
        }
        localStorage.setItem('version_data', version)
      })
    },
    initTimer() {
      if (!this.logged) {
        return
      }
      this.$store.dispatch('timer/init', { name: 'unReadTimer', fn: this.getUnReadList, time: 300000 }).catch(reason => {
        console.log(reason)
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.notice-container{
  width: 40px;
  text-align: center;
  >>> i {
    font-size: 16px;
    cursor: pointer;
  }
  >>> sup.el-badge__content {
    border-radius:0;
    top: 10px;
    cursor: pointer;
  }
  .notice-icon-box:hover,.notice-icon-box-animation{
    animation: notice-left-and-right .5s linear  infinite;
  }
}
@mixin transform-animate($deg) {
  transform:rotate($deg);
  -ms-transform:rotate($deg); /* Internet Explorer */
  -moz-transform:rotate($deg); /* Firefox */
  -webkit-transform:rotate($deg); /* Safari 和 Chrome */
  -o-transform:rotate($deg); /* Opera */
}
@keyframes notice-left-and-right {
  25% {
   @include transform-animate(15deg)
  }
  75% {
   @include transform-animate(-30deg)
  }
}
.notice-container:hover{
  background: #F5F7FA;
}
</style>
<style lang="scss">
.dropdown-message{
  width: 280px;
  .notice-content-group{
    border-bottom: 1px solid #eaeaea;
    padding: 0 15px;
  }
  .notice-content-title{
    display: block;
    color: #7d8c95;
    font-size: 12px;
    text-align: center;
    padding: 5px 0;
  }
  .notice-content {
    display: inline-block;
    width: 205px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 5px 0 0 5px;
  }
  .notice-content-icon{
    display: inline-flex;
    float: left;
    margin-top: 4px;
    margin-right: 10px;
    i{
      font-size: 25px;
      margin-right: 0!important;
    }
  }
  .notice-title {
    font-size: 14px;
    display: block;
  }
  .notice-title-context{
    width: 65%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 700
  }
  .notice-time{
    width: 35%;
    font-size: 12px;
    text-align: right;
    float: right;
  }
  .notice-message{
    font-size: 12px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
 .popper-message{
    max-width: 250px;
  }
  .dropdown-message-hidden{
    display: none;
  }
</style>
